<template>
  <div>
    <h1
      class="titulo m-0"
      :class="{'texto-azul' : blue, 'texto-blanco' : white}"
    >
      <slot></slot>
    </h1>
  </div>
</template>
<script>
export default {
  data() {
    return {
      blue: false,
      white: false
    };
  },
  props: {
    variant: {
      type: String
    }
  },
  created() {
    if (this.variant === "azul") {
      this.blue = true;
      this.white = false;
      this.black = false;
    } else if (this.variant === "blanco") {
      this.white = true;
      this.blue = false;
      this.black = false;
    } else if (this.variant === "negro") {
      this.black = true;
      this.white = false;
      this.blue = false;
    }
  }
};
</script>
<style scoped>
.titulo {
  font-size: calc(1.8em + 1vw);
  font-weight: 500;
  letter-spacing: -0.5px;
  color: #262626;
  text-shadow: 0px 0px 1.5px rgba(0, 0, 0, 0.2);
}
.texto-azul {
  color: rgba(20, 89, 186, 1);
}
.texto-blanco {
  text-shadow: 0px 0px 1.5px rgba(0, 0, 0, 0.4);
}
.texto-azul {
  text-shadow: 0px 0px 1.5px rgba(20, 89, 186, 0.4);
}
.texto-blanco {
  color: rgba(242, 242, 242, 1);
}
.texto-azul-claro {
  color: rgba(0, 156, 255, 1);
}
</style>